const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParkingRegister(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3592.9287,
    y1: 4066.9524,
    x2: 1112.6691,
    y2: 986.6255
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_1_)"
    },
    d: "M2910.594,2852.183c-56.97,59.976-110.875,98.654-153.465,129.213 c-500.629,359.207-1093.006,254.5-1218.903,228.929c-185.91-37.759-545.27-110.747-805.081-416.28 c-393.072-462.245-331.865-1190.499-26.972-1671.23c55.77-87.934,350.362-575.987,949.119-654.255 c362.361-47.367,784.759,48.167,1090.647,304.44C3388.026,1310.942,3342.316,2397.679,2910.594,2852.183z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121237680580359080570000006041659545249074588_",
    gradientUnits: "userSpaceOnUse",
    x1: 925.9425,
    y1: 3128.3108,
    x2: 3339.2622,
    y2: 558.2786
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121237680580359080570000006041659545249074588_)"
    },
    d: "M2837.581,661.18l142.951,344.962 c37.872,91.391,31.792,195.097-16.501,281.436l-289.863,518.232c-32.867,58.761-46.558,126.321-39.16,193.241l32.249,291.708 c12.088,109.342-32.284,217.322-117.76,286.572l0,0c-135.657,109.906-334.084,92.175-448.106-40.041l-180.788-209.636 c-84.755-98.278-102.488-237.728-45.029-354.091l189.503-383.77c24.212-49.031,35.583-103.405,33.051-158.03l-26.104-563.042 c-6.018-129.801,66.302-250.578,183.563-306.562l144.272-68.878C2566.922,413.524,2766.71,490.156,2837.581,661.18z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011017269097236085490000012868590293583802536_",
    gradientUnits: "userSpaceOnUse",
    x1: 2902.0405,
    y1: 1444.0947,
    x2: 4103.4702,
    y2: 514.2911
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9001,
    style: {
      stopColor: "#59246D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011017269097236085490000012868590293583802536_)"
    },
    d: "M2281.595,2704.956 c-25.359-452.048,43.077-910.518,104.956-1215.524c37.03-182.534,74.415-324.845,99.258-412.087 c16.535-58.074,28.823-96.404,36.222-118.336c16.049-47.582,19.289-49.641,24.197-52.76c7.698-4.893,17.898-2.614,22.783,5.075 c3.942,6.202,3.23,14.034-1.227,19.399c-23.175,44.109-300.653,927.061-253.23,1772.382c0.512,9.103-6.453,16.893-15.553,17.405 c-0.928,0.052-1.84,0.026-2.735-0.072C2288.386,2719.579,2282.055,2713.13,2281.595,2704.956z M2563.935,934.108 c0.012-0.008,0.026-0.017,0.037-0.024C2563.96,934.091,2563.947,934.1,2563.935,934.108z M2563.997,934.068 c0.002-0.003,0.007-0.004,0.007-0.004C2564.002,934.067,2564,934.066,2563.997,934.068z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114032784757979971530000012257897824658257831_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.494,
    y1: 4385.585,
    x2: 3060.646,
    y2: 1849.2057
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114032784757979971530000012257897824658257831_)"
    },
    d: "M2513.059,2118.743 c61.404-42.05,95.502-113.51,89.816-187.714c-6.07-79.22,6.35-167.744,39.656-255.604 c87.403-230.573,285.535-369.241,442.539-309.725c157.005,59.516,213.428,294.679,126.024,525.252 c-16.966,44.758-38.107,86.051-62.31,123.103c-36.7,56.185-44.218,126.549-19.047,188.76 c23.909,59.092,26.471,126.999,2.094,191.306c-33.285,87.806-108.62,147.341-194.4,164.385 c-50.812,10.096-95.938,38.544-126.482,80.387c-86.667,118.728-217.653,177.196-329.307,134.872 c-143.099-54.245-200.241-253.498-127.632-445.042C2388.626,2237.406,2446.483,2164.335,2513.059,2118.743z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145056522398186488840000006556299652375566236_",
    gradientUnits: "userSpaceOnUse",
    x1: -3986.8723,
    y1: 1409.7402,
    x2: -3631.7703,
    y2: 339.0963,
    gradientTransform: "matrix(-0.9351 -0.3544 -0.3544 0.9351 -651.2568 314.6416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145056522398186488840000006556299652375566236_)"
    },
    d: "M2343.677,3035.756 c3.702,1.024,7.828-0.111,10.464-3.241c130.307-154.642,262.347-443.11,350.168-657.873 c94.992-232.297,160.184-430.823,160.83-432.801c1.743-5.323-1.16-11.05-6.481-12.791c-5.303-1.74-11.051,1.159-12.792,6.482 c-2.579,7.88-260.765,791.418-507.232,1083.915c-3.609,4.282-3.062,10.679,1.22,14.288 C2341.006,3034.707,2342.312,3035.378,2343.677,3035.756z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012463260280726442340000001359577426660415930_",
    gradientUnits: "userSpaceOnUse",
    x1: 526.1525,
    y1: 1739.2617,
    x2: 2246.2354,
    y2: 1739.2617
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000012463260280726442340000001359577426660415930_)"
    },
    d: "M557.672,585.918 c-10.145,409.237-43.048,1820.851-27.341,2321.083c1.664,52.995,44.147,95.531,97.14,97.265 c262.105,8.577,1016.106,30.317,1444.82,12.331c89.295-3.746,160.304-76.075,162.157-165.43 c8.909-429.546,28.564-1637.699-18.154-2191.154c-5.598-66.312-57.645-119.12-123.863-125.744 c-285.444-28.555-1043.577-98.355-1413.96-74.319C611.674,464.284,559.331,518.999,557.672,585.918z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090286746558124345820000011412175463166266255_",
    gradientUnits: "userSpaceOnUse",
    x1: 1820.035,
    y1: 1086.9302,
    x2: -1647.4092,
    y2: 5522.6465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090286746558124345820000011412175463166266255_)"
    },
    d: "M664.173,713.077 c-14.316,335.162-59.469,1450.168-45.138,1862.475c2.095,60.264,49.593,108.993,109.79,112.515 c247.852,14.504,883.57,46.486,1247.108,17.375c65.461-5.241,116.829-58.182,120.363-123.757 c18.423-341.936,71.319-1380.163,57.581-1787.849c-2.192-65.037-52.572-118.152-117.385-123.971 c-268.136-24.074-956.801-81.357-1265.725-64.501C712.776,608.527,666.651,655.052,664.173,713.077z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#3F67F9"
    },
    d: "M1205.436,531.457L1205.436,531.457c0,12.558,9.786,22.914,22.326,23.57 c61.908,3.242,236.302,12.416,314.241,16.938c15.367,0.892,27.429-12.922,24.514-28.036l-0.498-2.579 c-1.989-10.314-10.542-18.076-21.002-19.035c-52.683-4.827-211.651-18.213-316.977-14.453 C1215.387,508.314,1205.436,518.797,1205.436,531.457z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.73,
      fill: "#FFFFFF"
    },
    d: "M2158.174,1355.9h-304.998c-16.644,0-30.155-13.456-30.224-30.099 c-1.12-272.769-2.108-640.105-0.276-675.012c-0.097,1.842-56.287-3.74-56.287-3.74c-0.893,17.805,0.35-7.239-0.059,29.919 c-0.233,21.086-0.394,51.375-0.482,90.027c-0.147,64.689-0.092,154,0.165,265.452c0.435,189.59,1.315,380.271,1.323,382.175 l0.098,21.063c0.094,20.207,16.501,36.538,36.708,36.538h63.588c11.039,0,19.988,8.949,19.988,19.988v346.896 c0,22.895-18.56,41.454-41.454,41.454h-158.62c-17.821,0-33.729-11.171-39.78-27.934l-122.251-338.708 c-7.06-19.561-25.625-32.597-46.42-32.597h-147.869c-12.484,0-21.736-11.595-18.964-23.768l188.956-829.936l-77.97-5.074 l-180.008,811.471c-6.131,27.638-30.64,47.307-58.951,47.307h-54.764c-20.143,0-36.457-16.331-36.403-36.474 c0.197-73.617,0.457-180.818,0.624-287.641c0.173-111.43,0.21-200.646,0.112-265.17c-0.198-128.678,4.219-277.576,2.202-285.955 c0,0-36.842-0.497-36.878-1.191c1.347,25.99,4.632,544.873,4.134,842.352c-0.031,18.831-15.302,34.079-34.133,34.079h-51.488 c-22.032,0-40.655-16.32-43.544-38.162c-32.236-243.767-109.534-827.511-111.676-840.851 c-35.434,0.827-67.812,2.708-84.819,9.894c0,0,85.574,644.004,125.044,942.676l0,0c3.235,24.474,24.102,42.764,48.789,42.764 h229.873c20.38,0,34.198,20.738,26.35,39.546l-161.489,387.046c-9.345,22.398-31.236,36.984-55.506,36.984H619.638 l-1.888,116.322H968.5c29.044,0,55.242-17.456,66.426-44.261l208.498-499.71c9.078-21.757,30.343-35.927,53.918-35.927h157.176 c18.796,0,35.575,11.783,41.957,29.463l80.892,224.12c5.152,14.274-5.424,29.335-20.599,29.335h-224.473 c-11.068,0-20.04,8.972-20.04,20.04v809.02h29.787v-729.078c0-21.047,17.062-38.109,38.109-38.109h193.309 c22.099,0,41.827,13.853,49.33,34.64l240.549,666.464l44.807-69.775l-217.674-603.089c-4.96-13.741,5.221-28.24,19.83-28.24 h206.066c21.388,0,38.726-17.338,38.726-38.725v-397.443c0-18.801,15.241-34.042,34.042-34.042h169.04V1355.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165205400662659279650000016029859165959255963_",
    gradientUnits: "userSpaceOnUse",
    x1: 777.9496,
    y1: 1299.1566,
    x2: 1939.8112,
    y2: 1299.1566
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165205400662659279650000016029859165959255963_)"
    },
    d: "M1922.898,1928.349h-286.752 c-7.014,0-13.301-4.331-15.802-10.885l-143.205-375.451H902.989c-8.503,0-15.685-6.315-16.775-14.75L778.09,689.042 c-1.193-9.264,5.347-17.742,14.612-18.937c9.258-1.198,17.74,5.347,18.937,14.61l106.222,823.473h570.925 c7.014,0,13.301,4.331,15.802,10.885l143.205,375.451h258.19v-476.565c0-9.34,7.573-16.913,16.913-16.913 c9.34,0,16.914,7.572,16.914,16.913v493.477C1939.811,1920.777,1932.238,1928.349,1922.898,1928.349z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165218171829942040680000002186798850070515639_",
    gradientUnits: "userSpaceOnUse",
    x1: 1834.925,
    y1: 1385.6891,
    x2: 2007.9899,
    y2: 1385.6891
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000165218171829942040680000002186798850070515639_)"
    },
    cx: 1921.458,
    cy: 1385.689,
    r: 86.532
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132059703722794808200000016174722027405371819_",
    gradientUnits: "userSpaceOnUse",
    x1: 3794.4497,
    y1: 135.5796,
    x2: 1986.5776,
    y2: 3428.1284
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C32B78"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#593092"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2745.916,
    y: 753.306,
    style: {
      fill: "url(#SVGID_00000132059703722794808200000016174722027405371819_)"
    },
    width: 93.137,
    height: 2414.164
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M3178.774,1216.851c0,104.042-84.342,188.384-188.384,188.384h-421.039 c-104.042,0-188.384-84.342-188.384-188.384V795.812c0-104.042,84.343-188.384,188.384-188.384h421.039 c104.042,0,188.384,84.342,188.384,188.384V1216.851z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103961553838748399440000002265521013627798169_",
    gradientUnits: "userSpaceOnUse",
    x1: 2733.1653,
    y1: 1679.9882,
    x2: 2780.6106,
    y2: 968.3121
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103961553838748399440000002265521013627798169_)"
    },
    d: "M3135.013,795.695 c0-81.667-66.204-147.871-147.871-147.871h-417.907c-81.667,0-147.871,66.204-147.871,147.871v417.907 c0,81.667,66.204,147.871,147.871,147.871h417.907c81.667,0,147.871-66.204,147.871-147.871V795.695z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2615.282,784.998c31.602-5.38,75.977-9.415,138.506-9.415 c63.199,0,108.248,12.103,138.503,36.307c28.911,22.862,48.41,60.513,48.41,104.888c0,44.375-14.792,82.026-41.687,107.576 c-34.962,32.946-86.733,47.737-147.246,47.737c-13.447,0-25.548-0.672-34.962-2.019v162.038h-101.525V784.998z  M2716.807,990.736c8.742,2.019,19.499,2.691,34.29,2.691c54.462,0,88.078-27.567,88.078-73.96 c0-41.684-28.911-66.562-80.01-66.562c-20.843,0-34.963,2.016-42.358,4.035V990.736z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011731205146423361300000011326451517118479501_",
    gradientUnits: "userSpaceOnUse",
    x1: 1482.1736,
    y1: 3007.5803,
    x2: 1704.3475,
    y2: 3007.5803
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011731205146423361300000011326451517118479501_)"
    },
    d: "M1704.348,2886.35 c0-50.172-40.673-90.845-90.845-90.845h-40.484c-50.172,0-90.845,40.673-90.845,90.845v242.46 c0,50.172,40.673,90.845,90.845,90.845h40.484c50.172,0,90.845-40.673,90.845-90.845V2886.35z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016044828628684142370000013458285441696869019_",
    gradientUnits: "userSpaceOnUse",
    x1: 2734.4265,
    y1: 3007.5803,
    x2: 2956.6006,
    y2: 3007.5803
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016044828628684142370000013458285441696869019_)"
    },
    d: "M2956.601,2886.35 c0-50.172-40.673-90.845-90.845-90.845h-40.484c-50.172,0-90.845,40.673-90.845,90.845v242.46 c0,50.172,40.673,90.845,90.845,90.845h40.484c50.172,0,90.845-40.673,90.845-90.845V2886.35z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093148423206213515080000000048698461368893356_",
    gradientUnits: "userSpaceOnUse",
    x1: 1441.7783,
    y1: 2436.719,
    x2: 1662.1862,
    y2: 2436.719
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093148423206213515080000000048698461368893356_)"
    },
    d: "M1602.814,2431.611 c-2.723-0.603-6.187-3.017-6.187-5.806v-18.669c0-17.989-8.607-34.444-24.671-42.542c-20.723-10.446-44.33-10.81-65.357-0.988 l-36.645,18.071c-18.435,8.612-28.176,27.118-28.176,47.465v14.235c0,26.202,17.7,48.375,43.662,51.909l158.251,21.659 l18.495-72.452L1602.814,2431.611z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086662606128617538240000013519203345495900862_",
    gradientUnits: "userSpaceOnUse",
    x1: -2393.4521,
    y1: 2436.719,
    x2: -2165.9629,
    y2: 2436.719,
    gradientTransform: "matrix(-1 0 0 1 620.375 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000086662606128617538240000013519203345495900862_)"
    },
    d: "M2844.097,2431.611 c2.723-0.603,4.783-3.017,4.783-5.806v-18.669c0-17.989,10.011-34.444,26.075-42.542c20.724-10.446,45.033-10.81,66.06-0.988 l40.641,18.071c18.435,8.612,32.172,27.118,32.172,47.465v14.235c0,26.202-21.345,48.375-47.307,51.909l-160.074,21.659 l-20.108-72.452L2844.097,2431.611z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165223527980721321960000017299544846926509734_",
    gradientUnits: "userSpaceOnUse",
    x1: 2225.626,
    y1: 2371.4395,
    x2: 2214.9727,
    y2: 3660.5066
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165223527980721321960000017299544846926509734_)"
    },
    d: "M2960.197,2591.797 c-23.031-77.738-142.025-149.754-142.025-149.754s-99.801-306.327-207.28-306.327c-86.302,0-293.54,0-371.864,0 c0,0-11.49,0-30.709,0c-78.407,0-286.015,0-372.336,0c-107.479,0-207.28,306.327-207.28,306.327s-118.994,71.952-142.025,149.69 c-16.837,56.832,19.667,276.087,40.517,388.884c7.352,39.768,44.877,70.725,88.698,70.725h592.425h30.709h591.954 c43.821,0,81.346-30.925,88.698-70.693C2940.531,2867.853,2977.035,2648.63,2960.197,2591.797z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052102160641543031490000009675769215738590377_",
    gradientUnits: "userSpaceOnUse",
    x1: 2335.9597,
    y1: 2077.7646,
    x2: 2164.2646,
    y2: 3390.7371
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052102160641543031490000009675769215738590377_)"
    },
    d: "M2945.248,2917.249 c-6.698-7.662-16.912-14.023-27.721-14.023H1529.349c-10.743,0-20.902,6.307-27.603,13.889 c-6.702,7.582-9.219,18.452-6.837,27.911l22.717,92.608c3.655,14.521,17.95,27.174,34.441,27.174h1341.608 c16.348,0,30.56-12.007,34.355-26.365l23.852-92.144C2954.39,2936.804,2951.946,2924.911,2945.248,2917.249z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161589737294162862980000006639658319200199058_",
    gradientUnits: "userSpaceOnUse",
    x1: 1812.6782,
    y1: 2190.0513,
    x2: 2115.6724,
    y2: 836.6753
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000161589737294162862980000006639658319200199058_)"
    },
    d: "M1848.515,2778.285 c0,0-34.546-103.64-78.05-112.597c-43.503-8.957-227.752-47.341-231.591-15.354c-3.838,31.988-40.944,142.025,69.094,152.261 C1718.006,2812.832,1866.241,2821.253,1848.515,2778.285z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086668432994688808450000015012663059330359482_",
    gradientUnits: "userSpaceOnUse",
    x1: -1760.0118,
    y1: 1391.2405,
    x2: -1457.0176,
    y2: 37.8638,
    gradientTransform: "matrix(-1 0 0 1 695.3475 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000086668432994688808450000015012663059330359482_)"
    },
    d: "M2598.36,2778.285 c0,0,34.547-103.64,78.05-112.597c43.504-8.957,227.752-47.341,231.591-15.354c3.839,31.988,40.945,142.025-69.093,152.261 C2728.87,2812.832,2580.635,2821.253,2598.36,2778.285z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135677255048593745580000010948350442130406589_",
    gradientUnits: "userSpaceOnUse",
    x1: 2223.438,
    y1: 1538.0345,
    x2: 2223.438,
    y2: 2891.4111
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000135677255048593745580000010948350442130406589_)"
    },
    d: "M2573.548,2688.195 c-3.574-5.507-9.693-10.509-16.258-10.509h-667.705c-6.8,0-13.102,5.242-16.608,11.068c-3.505,5.827-3.701,13.904-0.515,19.911 l37.568,72.627c13.94,26.287,41.261,44.509,71.016,44.509h490.606c31.73,0,60.491-20.032,73.414-49.011l29.926-68.629 C2577.665,2702.166,2577.122,2693.702,2573.548,2688.195z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065783108849717814690000013539235752167868037_",
    gradientUnits: "userSpaceOnUse",
    x1: 1687.6866,
    y1: 2347.791,
    x2: 2759.1892,
    y2: 2347.791
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53EAC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#45AED8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065783108849717814690000013539235752167868037_)"
    },
    d: "M2755.367,2467.744 c-4.338,6.602-11.708,11.332-19.653,11.332H1711.136c-8.023,0-15.508-4.844-19.807-11.638 c-4.299-6.794-4.837-15.685-1.382-22.978c23.261-49.018,66.905-139.945,91.356-190.728c1.113-2.303,2.342-4.621,3.724-6.733 c11.823-18.771,32.589-30.492,55.121-30.492h774.804c22.762,0,43.605,11.861,55.39,30.784c1.65,2.687,3.147,5.508,4.415,8.426 l82.451,189.425C2760.395,2452.396,2759.704,2461.104,2755.367,2467.744z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119100116124388182850000000968044694370590099_",
    gradientUnits: "userSpaceOnUse",
    x1: 1785.0282,
    y1: 2250.6018,
    x2: 2670.3435,
    y2: 2250.6018
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CFFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BFFFA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119100116124388182850000000968044694370590099_)"
    },
    d: "M2670.344,2247.291 c-54.277,10.709-213.767,37.406-454.327,37.406c-242.556,0-384.888-27.244-430.989-37.8 c11.823-18.771,32.589-30.391,55.121-30.391h774.804C2637.716,2216.507,2658.559,2228.367,2670.344,2247.291z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1832.005,2637.3c-0.948,0-1.897-0.349-2.639-1.05l-132.802-125.672 c-1.539-1.458-1.606-3.887-0.15-5.428c1.462-1.539,3.891-1.603,5.428-0.15l132.802,125.672 c1.539,1.459,1.606,3.887,0.15,5.428C1834.038,2636.896,1833.022,2637.3,1832.005,2637.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2605.093,2637.3c-1.018,0-2.034-0.403-2.789-1.2c-1.457-1.541-1.389-3.969,0.15-5.428 L2735.256,2505c1.541-1.453,3.972-1.389,5.428,0.15c1.457,1.541,1.389,3.969-0.15,5.428l-132.801,125.672 C2606.99,2636.95,2606.041,2637.3,2605.093,2637.3z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2552.949,1981.064c18.875-15.798,90.496-135.902,205.09-0.032 c12.399,6.466,44.46-11.656,40.378-24.351c-134.104-195.599-301.121-12.025-284.74,8.103 C2530.057,1984.913,2530.997,1999.44,2552.949,1981.064z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2879.31,1899.615c25.012-2.936,48.526-20,41.494-41.876 c-6.927-21.552-245.623-300.402-511.488,13.938c-3.262,3.859-4.849,8.858-4.409,13.89c0.439,5.033,2.868,9.683,6.75,12.915 c12.105,10.081,22.416,16.854,35.795,15.205C2690.734,1637.826,2854.297,1902.548,2879.31,1899.615z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M3003.566,1816.307c17.765,3.558,54.087-9.797,44.704-38.987 c-420.156-457.143-794.328,21.999-780.602,41.324c13.724,19.325,41.556,20.051,52.757,13.528 C2654.95,1403.072,2985.8,1812.748,3003.566,1816.307z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2709.38,2050.896c0,30.739-24.918,55.658-55.657,55.658s-55.657-24.919-55.657-55.658 c0-30.739,24.918-55.657,55.657-55.657S2709.38,2020.157,2709.38,2050.896z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172422167248943973930000017172852424705325491_",
    gradientUnits: "userSpaceOnUse",
    x1: 4638.145,
    y1: 3117.9155,
    x2: 4080.7249,
    y2: 3724.2329,
    gradientTransform: "matrix(1 0 0 1 -3363.6506 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000172422167248943973930000017172852424705325491_)"
    },
    d: "M1289.124,3247.107l-164.151-75.444 l-28.986-4.687c0,0-6.226,35.242-9.277,70.129L1289.124,3247.107z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153666756282359386730000001988648611065807799_",
    gradientUnits: "userSpaceOnUse",
    x1: 4454.5376,
    y1: 3166.8308,
    x2: 4507.9321,
    y2: 3166.8308,
    gradientTransform: "matrix(1 0 0 1 -3363.6506 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000153666756282359386730000001988648611065807799_)"
    },
    d: "M1090.887,3146.269l5.002,42.155 c0,0,28.755,13.386,48.392-1.687l-11.908-46.978L1090.887,3146.269z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130630562907056853820000014884351615565507472_",
    gradientUnits: "userSpaceOnUse",
    x1: 3007.8013,
    y1: 6213.478,
    x2: 2617.3145,
    y2: 7169.4971,
    gradientTransform: "matrix(1 0 0 1 -3363.6506 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000130630562907056853820000014884351615565507472_)"
    },
    d: "M1094.646,2353.746 c-2.161,11.008-11.596,549.349,45.948,790.597c0.939,3.936-1.057,7.994-4.803,9.525c-8.826,3.606-26.129,8.828-46.865,9.524 c-6.422,0.216-12.18-3.958-13.991-10.122c-16.448-55.974-95.268-336.416-105.551-604.314c-11.489-299.35,0-10.193,0-10.193 l6.739-185.04L1094.646,2353.746z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160170439266152759440000012373074504348838039_",
    gradientUnits: "userSpaceOnUse",
    x1: 4498.0752,
    y1: 3008.7378,
    x2: 3943.7122,
    y2: 3611.7297,
    gradientTransform: "matrix(1 0 0 1 -3363.6506 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160170439266152759440000012373074504348838039_)"
    },
    d: "M972.908,3255 c-2.095-17.257-8.623-45.569-28.789-67.635l-36.96-2.003c0,0-9.909,17.792-19.503,65.069L972.908,3255z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018226789271620190440000014149240719757684920_",
    gradientUnits: "userSpaceOnUse",
    x1: 4262.1055,
    y1: 3164.093,
    x2: 4308.207,
    y2: 3164.093,
    gradientTransform: "matrix(1 0 0 1 -3363.6506 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018226789271620190440000014149240719757684920_)"
    },
    d: "M898.455,3131.142l11.688,63.749 c0,0,11.555,8.596,34.414,2.365l-5.578-68.59L898.455,3131.142z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059277551341490563580000008337357326176360600_",
    gradientUnits: "userSpaceOnUse",
    x1: 2883.8989,
    y1: 6162.8696,
    x2: 2493.4104,
    y2: 7118.8926,
    gradientTransform: "matrix(1 0 0 1 -3363.6506 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059277551341490563580000008337357326176360600_)"
    },
    d: "M866.884,2370.266 c-47.064,284.033,10.209,702.011,29.525,783.819c1.182,5.009,5.224,8.846,10.301,9.688c8.622,1.429,22.817,2.595,36.811-1.469 c4.822-1.4,8.209-5.75,8.406-10.767c2.591-66.14-2.073-472.172,41.78-632.639c2.222-8.132,7.188-15.224,14.06-20.109 l85.115-60.51l6.526-97.808L866.884,2370.266z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031911029249715070660000003027658485552749974_",
    gradientUnits: "userSpaceOnUse",
    x1: 3477.5811,
    y1: 4378.6621,
    x2: 3214.9863,
    y2: 5025.0513,
    gradientTransform: "matrix(1 0 0 1 -3363.6506 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031911029249715070660000003027658485552749974_)"
    },
    d: "M1166.775,1832.079 c-141.041-2.33-296.663,37.033-296.663,37.033c-42.042,245.31-7.352,528.259-7.352,528.259 c109.19,28.634,232.363-17.507,232.363-17.507c18.148-102.534,102.823-391.098,102.823-391.098 c68.912-8.552,125.681-28.435,172.431-54.721c-35.66-41.334-52.471-93.931-59.772-125.022 C1260.737,1824.52,1210.277,1832.798,1166.775,1832.079z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143602224552001584620000004066822475878484893_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.3101,
    y1: 1456.0251,
    x2: 164.5169,
    y2: 1725.1884,
    gradientTransform: "matrix(-1 0 0 1 1611.6316 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143602224552001584620000004066822475878484893_)"
    },
    d: "M1583.385,1624.333 c-13.855-16.735-31.391-8.818-31.391-8.818c-20.755,87.673-129.584,158.76-241.39,193.507 c7.301,31.091,24.112,83.687,59.772,125.022C1555.928,1829.715,1583.385,1624.333,1583.385,1624.333z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126286557286124649400000002334583436748475562_",
    gradientUnits: "userSpaceOnUse",
    x1: -10.2097,
    y1: 1484.207,
    x2: 83.9968,
    y2: 1753.369,
    gradientTransform: "matrix(-1 0 0 1 1611.6316 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126286557286124649400000002334583436748475562_)"
    },
    d: "M1580.022,1628.588 c1.45,4.609-15.338,11.627-25.223-7.223c-0.347-9.033-5.84-47.736-0.442-55.096c28.75-39.196,84.491-88.331,84.491-88.331 c9.42,9.295,1.66,18.427,1.66,18.427l-27.041,28.169c5.656,10.221,12.555,18.848,15.788,31.211 c2.449,9.362,0.951,19.367-3.778,27.889c-4.746,8.551-11.222,19.667-17.345,28.366 C1596.545,1628.465,1580.022,1628.588,1580.022,1628.588z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074442957154543154280000016090995885747336864_",
    gradientUnits: "userSpaceOnUse",
    x1: 62.1616,
    y1: 1656.1746,
    x2: -8.8002,
    y2: 1513.0272,
    gradientTransform: "matrix(-1 0 0 1 1611.6316 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000074442957154543154280000016090995885747336864_)"
    },
    d: "M1601.64,1542.811l-24.642,20.889 l-7.737,20.798l21.971,24.373c0,0,7.387-41.267,12.877-50.199C1609.6,1549.742,1606.753,1545.423,1601.64,1542.811z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148655388875480092290000016834635234932797585_",
    gradientUnits: "userSpaceOnUse",
    x1: 3266.4216,
    y1: 4292.8921,
    x2: 3003.8271,
    y2: 4939.2808,
    gradientTransform: "matrix(1 0 0 1 -3363.6506 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000148655388875480092290000016834635234932797585_)"
    },
    d: "M924.209,2005.681l-54.098-136.569 c0,0-131.741,89.512-153.406,203.003c24.892,1.833,70.188,8.308,114.524,30.695 C840.973,2049.22,924.209,2005.681,924.209,2005.681z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067949412589361368160000011101428242504269503_",
    gradientUnits: "userSpaceOnUse",
    x1: 4077.3528,
    y1: 2160.2312,
    x2: 4422.5596,
    y2: 2160.2312,
    gradientTransform: "matrix(1 0 0 1 -3363.6506 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067949412589361368160000011101428242504269503_)"
    },
    d: "M1039.334,2134.188 c0,0-147.91,83.592-197.818,12.215c-10.362-14.822-12.839-29.551-10.286-43.594c-44.336-22.386-89.633-28.862-114.524-30.695 c-6.532,34.214-3.079,70.603,17.026,107.38c87.421,159.917,325.178-8.838,325.178-8.838L1039.334,2134.188z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163761340414066824320000001630119509643479684_",
    gradientUnits: "userSpaceOnUse",
    x1: 4526.9976,
    y1: 1914.7999,
    x2: 4716.8145,
    y2: 2705.7056,
    gradientTransform: "matrix(1 0 0 1 -3363.6506 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163761340414066824320000001630119509643479684_)"
    },
    d: "M1021.563,2239.941l80.725-281.908 c0.916-3.2,3.645-5.534,6.953-5.919c14.626-1.706,57.005-6.496,105.937-10.636c58.941-4.986,127.388-9.025,168.289-5.588 c5.815,0.488,9.329,6.639,6.744,11.87c-23.26,47.056-118.934,238.471-166.844,301.175c-1.588,2.078-4.042,3.292-6.656,3.268 l-187.294-1.743C1023.966,2250.409,1020.063,2245.18,1021.563,2239.941z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036957305760029963870000005997896044289377417_",
    gradientUnits: "userSpaceOnUse",
    x1: 4396.9297,
    y1: 2124.0366,
    x2: 4504.4756,
    y2: 2124.0366,
    gradientTransform: "matrix(1 0 0 1 -3363.6506 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036957305760029963870000005997896044289377417_)"
    },
    d: "M1041.066,2171.832 c0,0-11.245-46.239-6.709-62.643c4.537-16.405,13.325-37.497,42.619-32.81c29.294,4.687,63.849,17.027,63.849,17.027 s-1.746,21.368-24.01,14.474l13.806,10.682c0,0-1.974,17.108-20.779,7.969l12.841,14.167c0,0-8.076,14.052-21.912,5.039 C1086.936,2136.725,1080.303,2177.4,1041.066,2171.832z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089565022320208984760000011340007456792969114_",
    gradientUnits: "userSpaceOnUse",
    x1: 4342.4243,
    y1: 1791.1841,
    x2: 4478.9072,
    y2: 1791.1841,
    gradientTransform: "matrix(1 0 0 1 -3363.6506 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089565022320208984760000011340007456792969114_)"
    },
    d: "M1023.912,1717.575l-44.877,129.782 c-0.743,2.15,0.14,4.53,2.131,5.631c12.233,6.764,56.306,26.314,109.418-7.36c5.533-3.508,9.299-9.229,10.14-15.727 l14.533-112.326H1023.912z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132781463894988151390000012265175936232891307_",
    gradientUnits: "userSpaceOnUse",
    x1: -2128.6587,
    y1: 1461.1987,
    x2: -2179.6609,
    y2: 1292.9814,
    gradientTransform: "matrix(0.746 -0.6659 0.6659 0.746 1762.6848 -803.1727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132781463894988151390000012265175936232891307_)"
    },
    d: "M1121.558,1597.394 c0,0,49.28,92.764,42.963,130.236c-6.317,37.471-67.391,34.781-120.724,4.348l-37.267-100.164L1121.558,1597.394z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094617445176582521820000001629153438154432163_",
    gradientUnits: "userSpaceOnUse",
    x1: 1028.5112,
    y1: 1432.2461,
    x2: 1080.5083,
    y2: 1728.8215
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000094617445176582521820000001629153438154432163_)"
    },
    d: "M1090.202,1519.516 c-53.834,30.897-105.742,51.94-117.483,77.878c-11.741,25.937-12.359,40.15-3.708,47.565c8.651,7.415,0.009,63.542,47.582,82.496 c0.007,0.002,0.014,0.004,0.021,0.008c6.561,2.612,14.025,1.431,19.458-3.079c5.434-4.511,7.953-11.624,6.6-18.555l-4.365-22.352 c0,0,1.846,2.514,8.708,2.081c6.862-0.432-4.688-16.458-7.595-23.087c-2.907-6.628-13.125-23.127,3.344-23.512 c16.469-0.386,86.941-10.273,104.024-37.463C1163.871,1574.307,1144.037,1488.619,1090.202,1519.516z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008870700250077309980000012068398071144266369_",
    gradientUnits: "userSpaceOnUse",
    x1: -2180.7954,
    y1: 1460.415,
    x2: -2226.6829,
    y2: 1309.0671,
    gradientTransform: "matrix(0.746 -0.6659 0.6659 0.746 1762.6848 -803.1727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008870700250077309980000012068398071144266369_)"
    },
    d: "M1051.769,1688.55 c0,0-35.087-24.074-37.651-3.801c-2.563,20.273,31.597,29.365,48.516,21.807L1051.769,1688.55z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1127.619,1600.467c-0.427,0-0.857-0.147-1.207-0.449c-0.775-0.666-0.864-1.835-0.201-2.612 c1-1.168,24.134-29.06-5.827-67.689c-0.627-0.811-0.48-1.974,0.328-2.602c0.814-0.623,1.982-0.476,2.602,0.328 c31.87,41.094,5.974,72.07,5.709,72.38C1128.657,1600.247,1128.141,1600.467,1127.619,1600.467z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingRegister);
export default __webpack_public_path__ + "static/media/parking_register.67be2100f3a6fb99e0b4fd66d0eb86ef.svg";
export { ForwardRef as ReactComponent };